export default __webpack_public_path__ + "static/media/lock.22b292ed.svg";